/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React TS Base Styles
import borders from 'src/assets/md-theme/base/borders';
import colors from 'src/assets/md-theme/base/colors';

// Material Dashboard 2 PRO React TS Helper Functions
import pxToRem from 'src/assets/md-theme/functions/pxToRem';

const { borderWidth } = borders;
const { light } = colors;

// types
type Types = any;

const tableCell: Types = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(4)} ${pxToRem(8)}`, // Reduced padding to match shadcn style (py-1 px-2)
      borderBottom: `${borderWidth[1]} solid ${light.main}`,
      verticalAlign: 'middle',
      '&:has([role=checkbox])': {
        paddingRight: 0,
      },
      '& [role=checkbox]': {
        transform: 'translateY(2px)',
      },
    },
  },
};

export default tableCell;
